var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/helpers/extends", "@babel/runtime-corejs2/helpers/objectWithoutProperties", "react", "prop-types", "../SectionBreadcrumb/SectionBreadcrumb"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/helpers/extends"), require("@babel/runtime-corejs2/helpers/objectWithoutProperties"), require("react"), require("prop-types"), require("../SectionBreadcrumb/SectionBreadcrumb"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.objectWithoutProperties, global.react, global.propTypes, global.SectionBreadcrumb);
    global.SectionTitle = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _extends2, _objectWithoutProperties2, _react, _propTypes, _SectionBreadcrumb) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _objectWithoutProperties2 = _interopRequireDefault(_objectWithoutProperties2);
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _SectionBreadcrumb = _interopRequireDefault(_SectionBreadcrumb);

  var SectionTitle = function SectionTitle(_ref) {
    var logo = _ref.logo,
        title = _ref.title,
        url = _ref.url,
        tracking = _ref.tracking,
        otherProps = (0, _objectWithoutProperties2.default)(_ref, ["logo", "title", "url", "tracking"]);
    return /*#__PURE__*/_react.default.createElement(_SectionBreadcrumb.default, (0, _extends2.default)({
      links: [{
        logo: logo,
        title: title,
        url: url,
        tracking: tracking
      }]
    }, otherProps));
  };

  SectionTitle.propTypes = {
    className: _propTypes.default.string,
    code: _propTypes.default.string,
    description: _propTypes.default.string,
    logo: _propTypes.default.string,
    title: _propTypes.default.string.isRequired,
    url: _propTypes.default.string,
    tracking: _propTypes.default.shape(),
    titleLevel: _propTypes.default.oneOf([1, 2, 3, 4, 5, 6])
  };
  SectionTitle.defaultProps = {
    code: '',
    description: '',
    url: ''
  };
  var _default = SectionTitle;
  _exports.default = _default;
});